module.exports = __webpack_public_path__ + "img/Frame-left1.458bf44d.png";